module.exports = __webpack_public_path__ + "static/media/quickstart.2c7e19b8.svg";